/* eslint-disable camelcase */
import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationOptions } from 'react-query';
import httpClient from 'utils/httpClient';

const APPROVAL_RESCHEDULE = '/v2/teacher/change-schedule-responsive';

export interface Response {}
export interface Body {
  course_id: number;
  unit_id: number;
  teacher_id: number;
  status: number;
  schedule_id: number | null | string;
}
export const updateApprovalReschedule = ({
  course_id,
  unit_id,
  teacher_id,
  status,
  schedule_id,
}: Body) => {
  return httpClient.post<Response>(APPROVAL_RESCHEDULE, {
    course_id,
    unit_id,
    teacher_id,
    status,
    schedule_id,
  });
};

export const useUpdateApprovalReschedule = (
  params?: UseMutationOptions<AxiosResponse<Response>, AxiosError<any>, Body>,
) => {
  return useMutation<AxiosResponse<Response>, AxiosError<any>, Body>(
    updateApprovalReschedule,
    params,
  );
};
